import loadActions from './load';
import analyticsActions from './analytics';

export default {
    ...loadActions,
    ...analyticsActions,
};
